// eslint-disable-next-line import-x/prefer-default-export
export const selectIsGloballyLoading = (state) => state.globalLoading.requestCount > 0
